// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ctc-container {
  max-width: auto;
  margin: 40px auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 10px;
  background-color: #f9f9f9;
}
.backBtn{
  background-color: transparent;
  color: black;
  border: 1px solid rgba(222, 214, 214, 0.617);
}
.backBtn:hover{
  background-color: rgba(222, 214, 214, 0.617);
  /* color: black;
  border: 1px solid rgba(222, 214, 214, 0.617); */
}

.ctc-container h2 {
  text-align: center;
  margin-bottom: 20px;
}

.ctc-form {
  display: flex;
  flex-direction: column;
  /* gap: 15px; */
}

.ctc-form label {
  display: flex;
  flex-direction: column;
  font-weight: 500;
}

.ctc-form input,
.ctc-form select {
  padding: 8px;
  font-size: 16px;
  border: 1px solid #aaa;
  border-radius: 5px;
}
.ctc-form-option{
  padding: 8px;
  border-bottom: #6f6f6f solid 2px !important;
}

.ctc-form button {
  padding: 5px 8px;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  background-color: rgb(116, 197, 167);
  gap: 12px;
  height: 33px;
  width: 84px;
  margin-top: 20px;
  margin-left: auto;
}

.ctc-form button:disabled {
  background-color: #999;
}

.submit-message {
  margin-top: 10px;
  font-weight: bold;
  color: green;
  text-align: center;
}
.ctc_main_inputs,
.ctc_validity {
  display: flex;
  justify-content: space-between;
}
.ctc_main_inputs input[type="number"]{
  margin-top: 5px;
}
.ctc_main_inputs select{
  padding: 6px;
}



.ctc-breakup-preview {
  margin-top: 20px;
  background: #f9f9f9;
  padding: 15px;
  border-radius: 8px;
}
.ctc-breakup-preview h3 {
  margin-bottom: 10px;
}

.ctc-breakup-preview table {
  width: 100%;
  border-collapse: collapse;
}

.ctc-breakup-preview th,
.ctc-breakup-preview td {
  border: 1px solid #ccc;
  padding: 8px;
  text-align: center;
}

.ctc-breakup-preview td input[type="number"] {
 font-size: 11px;
 font-weight: bold;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/GenerateSalaryComponent/SalaryStructure/SalaryStructure.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,6BAA6B;EAC7B,YAAY;EACZ,4CAA4C;AAC9C;AACA;EACE,4CAA4C;EAC5C;iDAC+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,SAAS;EACT,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;AACpB;AACA;;EAEE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;AACd;;;;AAIA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;EAChB,kBAAkB;AACpB","sourcesContent":[".ctc-container {\n  max-width: auto;\n  margin: 40px auto;\n  padding: 20px;\n  border: 1px solid #ccc;\n  border-radius: 10px;\n  background-color: #f9f9f9;\n}\n.backBtn{\n  background-color: transparent;\n  color: black;\n  border: 1px solid rgba(222, 214, 214, 0.617);\n}\n.backBtn:hover{\n  background-color: rgba(222, 214, 214, 0.617);\n  /* color: black;\n  border: 1px solid rgba(222, 214, 214, 0.617); */\n}\n\n.ctc-container h2 {\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.ctc-form {\n  display: flex;\n  flex-direction: column;\n  /* gap: 15px; */\n}\n\n.ctc-form label {\n  display: flex;\n  flex-direction: column;\n  font-weight: 500;\n}\n\n.ctc-form input,\n.ctc-form select {\n  padding: 8px;\n  font-size: 16px;\n  border: 1px solid #aaa;\n  border-radius: 5px;\n}\n.ctc-form-option{\n  padding: 8px;\n  border-bottom: #6f6f6f solid 2px !important;\n}\n\n.ctc-form button {\n  padding: 5px 8px;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  background-color: rgb(116, 197, 167);\n  gap: 12px;\n  height: 33px;\n  width: 84px;\n  margin-top: 20px;\n  margin-left: auto;\n}\n\n.ctc-form button:disabled {\n  background-color: #999;\n}\n\n.submit-message {\n  margin-top: 10px;\n  font-weight: bold;\n  color: green;\n  text-align: center;\n}\n.ctc_main_inputs,\n.ctc_validity {\n  display: flex;\n  justify-content: space-between;\n}\n.ctc_main_inputs input[type=\"number\"]{\n  margin-top: 5px;\n}\n.ctc_main_inputs select{\n  padding: 6px;\n}\n\n\n\n.ctc-breakup-preview {\n  margin-top: 20px;\n  background: #f9f9f9;\n  padding: 15px;\n  border-radius: 8px;\n}\n.ctc-breakup-preview h3 {\n  margin-bottom: 10px;\n}\n\n.ctc-breakup-preview table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.ctc-breakup-preview th,\n.ctc-breakup-preview td {\n  border: 1px solid #ccc;\n  padding: 8px;\n  text-align: center;\n}\n\n.ctc-breakup-preview td input[type=\"number\"] {\n font-size: 11px;\n font-weight: bold;\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
